import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

import FulfillmentOrderSummary from './FulfillmentOrderSummary';
import OrderAttentionPanel from './OrderAttentionPanel';
import OrderHistory from './OrderHistory';
import PackingChecklistEditor from './PackingChecklistEditor';
import ParcelIdentityPanel from './ParcelIdentityPanel';
import ParcelReadinessCard from './ParcelReadinessCard';
import RiderHandoffCard from './RiderHandoffCard';
import WorkflowStageRail from './WorkflowStageRail';
import { orderAttention } from '../../utils/orderAttention';

const panel = 'rounded-2xl border border-neutral-200 bg-white p-4 dark:border-neutral-800 dark:bg-neutral-950';

export default function FulfillmentTaskContent({ order, step, query, busy, success, onSave, onAction, onParcelCommand, onPackingDirtyChange }) {
  const attention = orderAttention(order);
  // An order that is held, failed or waiting on a payment is not on the pack ->
  // label -> handoff path. Showing those steps would point staff at work the
  // server will refuse, so the page shows why it stopped and where it resumes.
  const offPath = Boolean(attention?.blocksWorkflow);
  const readinessMessages = new Set((order?.readiness?.blockers || []).map(blocker => blocker?.message?.trim()).filter(Boolean));
  const showGeneralBlocker = Boolean(!attention && order?.blocker && !readinessMessages.has(order.blocker.trim()));
  return <div className="space-y-5">
    {success ? <div role="status" className="rounded-xl border border-success bg-success-subtle p-3 text-sm text-success">{success}</div> : null}
    {offPath ? null : <WorkflowStageRail order={order} currentStep={step} query={query} />}
    <OrderAttentionPanel order={order} attention={attention} />
    <FulfillmentOrderSummary order={order} />
    {showGeneralBlocker ? <div className="flex gap-3 rounded-xl border border-warning bg-warning-subtle p-4 text-sm text-warning"><AlertTriangle className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" /><div><p className="font-semibold">Action needed</p><p className="mt-1">{order.blocker}</p></div></div> : null}
    {offPath ? (
      <div className={panel}>
        <OrderHistory timeline={order.timeline} headingId="fulfillment-history" title="What has happened so far" />
        <Link to={`/business/orders/record/${order.orderId}`} className="mt-4 inline-flex min-h-11 items-center text-sm font-semibold underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus">Open the full order record</Link>
      </div>
    ) : null}
    {!offPath && step === 'pack' ? <div className="grid items-start gap-5 xl:grid-cols-[minmax(0,1.35fr)_minmax(20rem,.65fr)]"><PackingChecklistEditor order={order} busy={busy} onSave={onSave} onAction={onAction} onDirtyChange={onPackingDirtyChange} /><div className={panel}><OrderHistory timeline={order.timeline} headingId="fulfillment-activity-title" title="Activity" /></div></div> : null}
    {!offPath && step === 'label' ? <div className="grid items-start gap-5 xl:grid-cols-2"><ParcelIdentityPanel order={order} busy={busy} onCommand={onParcelCommand} /><ParcelReadinessCard order={order} /></div> : null}
    {!offPath && step === 'handoff' ? <RiderHandoffCard order={order} /> : null}
  </div>;
}
